import { CONTACT_INFO } from "./commanDetails";


export const openWhatsApp = (cake) => {
  let message = "";

  const offerPrice = cake.price === '900'?'1200':'1000'

  if (!cake || !cake.name) {
    // General message
    message = `Hi 👋I would like to enquire about your cakes.`;
  } else {
    // Cake specific message
    message = `
Hi 👋I would like to order this cake 🍰

Cake Name: ${cake.name}
Offer Price: ₹${offerPrice}
🎉 Offer: BUY 1 GET 1 FREE
Note: You may choose another cake flavor within the offer price.
`;
  }

 
  const url = `https://wa.me/${CONTACT_INFO.whatsapp}?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

export const openInstagram = () => {
  window.open("https://www.instagram.com/caramel_cottage_/#", "_blank");
};

// export const openFacebook = () => {
//   window.open("https://www.facebook.com/your_cakeshop", "_blank");
// };

// export const openYouTube = () => {
//   window.open("https://www.youtube.com/@your_cakeshop", "_blank");
// };

// export const openTwitter = () => {
//   window.open("https://twitter.com/your_cakeshop", "_blank");
// };
